export const disabledInfoIcon = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>编组 5</title>
    <g id="权益激活" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="SaasH5/权益激活-权益券2备份-4" transform="translate(-26.000000, -342.000000)">
            <g id="编组-6备份-7" transform="translate(10.000000, 208.000000)">
                <g id="编组-5" transform="translate(16.000000, 134.000000)">
                    <rect id="矩形" fill="currentColor" x="5.32645607" y="2.95517921" width="1.2" height="4" rx="0.6"></rect>
                    <rect id="矩形备份-3" fill="currentColor" x="5.31931305" y="7.44217491" width="1.2" height="1.2" rx="0.6"></rect>
                    <circle id="椭圆形" stroke="currentColor" stroke-width="1.2" cx="6" cy="6" r="5.4"></circle>
                </g>
            </g>
        </g>
    </g>
</svg>`

export const disabledCheckIcon = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>矩形</title>
    <g id="权益激活" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="SaasH5/权益激活-权益券2备份-5" transform="translate(-331.000000, -806.000000)" fill="currentColor" stroke="#E5E5E5">
            <g id="编组-6备份-9" transform="translate(10.000000, 770.000000)">
                <g id="休息室列表备份" transform="translate(16.000000, 20.000000)">
                    <rect id="矩形" x="305.5" y="16.5" width="17" height="17" rx="8.5"></rect>
                </g>
            </g>
        </g>
    </g>
</svg>`
